import useDisableBodyScroll from "@view/common/HelpersHooks/useDisableBodyScroll";
import { ReactNode, useState } from "react";

export interface INotificationModalAttributes {
  variant?: "success" | "error" | "warning" | "custom";
  title?: string;
  description?: string;
  actionLabel?: string;
  disableCloseButton?: boolean;
  onAction?: () => void;
  onClose?: () => void;
  image?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  closeLabel?: string
}

export const useNotificationModal = () => {
  const [open, setOpen] = useState(false);
  const [attributes, setAttributes] = useState({} as INotificationModalAttributes);

  useDisableBodyScroll(open);

  return {
    openNotificationModal: (props: INotificationModalAttributes) => {
      setAttributes(props);
      setOpen(true);
    },

    closeNotificationModal: () => setOpen(false),

    notificationModalProps: {
      ...attributes,
      open: open,
      onClose: attributes.disableCloseButton
        ? undefined
        : () => { 
          setOpen(false); 
          if(attributes.onClose) attributes.onClose(); 
        },
      onAction: attributes.actionLabel 
        ? attributes.onAction ?? (() => { setOpen(false); })
        : undefined
    }
  };
}
